import type { ZodType } from 'zod/v4';

export type ActionDefinition = {
  name: string;
  description: string;
  parameters: ZodType;
  category: string;
};

export type ActionResult = {
  success: boolean;
  state?: Record<string, unknown>;
  error?: string;
};

export type ExecuteCallback = (params: unknown) => ActionResult | Promise<ActionResult>;

export type TriggerCallback = () => ActionResult | Promise<ActionResult>;

export const EXECUTOR_SLOT = 'executor';
export const PAGE_SLOT = 'page';

export type BindOptions = {
  slot: string;
};

export type ToolCatalogEntry = {
  id: string;
  name: string;
  description: string;
  parameters: object;
  category: string;
};
